<template>
    <div class="echart" :id="id"></div>
</template>
<script>
export default {
    name:'lineChart',
    data(){
         return {
             chart:''
         }
    },
    props: {
        id:{
            type:String
        },
        dataArray: { 
            type: Array | Object
        },
		percentage:{
			type: Boolean,
			default:false
		},
        isShowLegend: { 
            type: Boolean,
            default:function(){
               return true 
            }
        },
        itemHeight:{
            type:Number,
            default:10
        },
        isShowArea: { 
            type: Boolean,
            default:function(){
               return true 
            }
        },
        gridBot:{
            type:String,
            default:'35'
        },
		dottedLine:{//是否需要加虚线
			type: Boolean,
			default:function(){
			   return false 
			}
		},
        colorArr:{
            type: Array,
            default: function () {
                return ["#0097e2", "#ff8121", "#e52e45", "#7737c7", "#4d4d4d", "#bd7f03", "#30d258"]
            }
        }
    },
    mounted() {
        let that = this
        that.$nextTick(()=> {
            that.init();
        })
    },
    watch: {
        dataArray: function (n, o) {
            this.init();
        }
    },
    methods: {
        lineOption:function(){
            let _this = this;
            let dtname = this.dataArray.dataName;
			let tooltip = '';
			if(_this.percentage){
				tooltip = {
					trigger: 'axis',//'{b}:\n{c}%'
					formatter: function(datas){
						let res = datas[0].name + '<br/>'
						for (var i = 0, length = datas.length; i < length; i++) {
							if(datas.value == '-'){
								
							}
							if(i > 0){
								res += '<br/>'
							}
							res +=datas[i].seriesName + ' ';
							res +=datas[i].value + '%';
						}
						return res;	
					}
				}
			}else{
				tooltip = {
					trigger: 'axis',
					formatter: function (params, ticket, callback) {  
						var htmlStr = ''; 
						var valMap = {};
						for(var i=0;i<params.length;i++){  
							var param = params[i];  
							var xName = param.name;//x轴的名称  
							var seriesName = param.seriesName;//图例名称  
							var value = param.value;//y轴值  
							var color = param.color;//图例颜色  
							
							//过滤无效值
							if(value == '-'){
								continue;
							}
							
							//过滤重叠值
							if(valMap[seriesName] == value){
								continue;
							}
							  
							if(i===0){  
							  htmlStr += xName + '<br/>';//x轴的名称  
							}  
							htmlStr +='<div>';  
							//为了保证和原来的效果一样，这里自己实现了一个点的效果  
							htmlStr += '<span style="margin-right:5px;display:inline-block;width:10px;height:10px;border-radius:5px;background-color:'+color+';"></span>';  
							  
							//圆点后面显示的文本  
							htmlStr += seriesName + '：' + value;  
							  
							htmlStr += '</div>';  
							valMap[seriesName] = value;
						}  
						return htmlStr;  
					}
				}
			}
            let option = {
				tooltip: tooltip,
                legend: {
                    show:_this.isShowLegend,
                    data:dtname,
                    textStyle: {
                        color: '#8a8a99',
                        fontSize:'14'
                    },
                    top:'bottom',
                    left:'center',
                    itemHeight: _this.itemHeight,
                    itemGap: _this.itemHeight,
                },
                grid: {
                    top: '30',
                    left: '10',
                    right: '10',
                    bottom: _this.gridBot,
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            title: '下载',
                        }
                    }
                },
                color: _this.colorArr,
                calculable : true,
                xAxis : [
                    {
                        type : 'category',
                        //boundaryGap : false,
                        data : _this.dataArray.datetime,
                        axisTick: {
                            alignWithLabel: true
                        },
                        axisLine: {
                            show: true,
                            lineStyle:{
                                color:'#ebebeb',
                            }
                        },
                        axisLabel : {
                            formatter: '{value}',
                            margin:15,
                            textStyle: {
                                color: '#8a8a99',
                                fontSize:'12'
                            }
                        },
                        splitLine: {
                            show: false,
                            lineStyle: {
                                color: ['#ebebeb']
                            }  
                        },
                    }
                ],
                yAxis : [
                    {
                        type : 'value',
                        axisTick: {
                            textStyle: {
                                color: '#aaa'
                            }
                        },
                        axisLine: {
                            show: false,
                            lineStyle:{
                                color:'#ebebeb',
                            }
                        },
                        axisLabel : {
                            formatter: '{value}',
                            textStyle: {
                                color: '#8a8a99',
                                fontSize:'12'
                            }
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: ['#ebebeb']
                            }  
                        },
                    }
                ],
                series:_this.getLineSeries(dtname)
            }
            return option;
        },
        getLineSeries:function(dtname){
            let seriesArr =[],_this = this,colorArea;
            if(_this.isShowArea){
                colorArea = [
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(18, 176, 255, .3)'},
                            {offset: 1,color: 'rgba(0, 151, 226, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(255, 139, 50,.3)'},
                            {offset: 1,color: 'rgba(255, 129, 33,0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(255, 51, 78, .3)'},
                            {offset: 1,color: 'rgba(229, 46, 69, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(119, 55, 199, .3)'},
                            {offset: 1,color: 'rgba(119, 55, 199, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(77, 77, 77, .3)'},
                            {offset: 1,color: 'rgba(77, 77, 77, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(189, 127, 3, .3)'},
                            {offset: 1,color: 'rgba(189, 127, 3, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(48, 210, 88, .3)'},
                            {offset: 1,color: 'rgba(48, 210, 88, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(18, 176, 255, .3)'},
                            {offset: 1,color: 'rgba(0, 151, 226, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(255, 139, 50,.3)'},
                            {offset: 1,color: 'rgba(255, 129, 33,0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(255, 51, 78, .3)'},
                            {offset: 1,color: 'rgba(229, 46, 69, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(119, 55, 199, .3)'},
                            {offset: 1,color: 'rgba(119, 55, 199, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(77, 77, 77, .3)'},
                            {offset: 1,color: 'rgba(77, 77, 77, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(189, 127, 3, .3)'},
                            {offset: 1,color: 'rgba(189, 127, 3, 0)'}
                        ])
                    },
                    {
                        color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                            {offset: 0,color: 'rgba(48, 210, 88, .3)'},
                            {offset: 1,color: 'rgba(48, 210, 88, 0)'}
                        ])
                    }
                ];
            }else{
                colorArea=[];
            }
            console.log(_this.dottedLine);
            if(_this.dottedLine){
				for(var i=0;i<dtname.length;i++){
					let color = colorArea[i];
                    let datas = _this.dataArray.data[dtname[i]];
                    if(typeof(datas[0]) === 'object'){
                        for(let j in datas){
                            var tempSeries = _this.setLineSeries(dtname[i], color, datas[j], j);
                            seriesArr.push(tempSeries);
                        }
                    }else{
                        var tempSeries = _this.setLineSeries(dtname[i], color, datas, 1);
                        
                        seriesArr.push(tempSeries);
                    }
				}
			}else{
				for(var i=0;i<dtname.length;i++){
				    var tempSeries = _this.setLineSeries(dtname[i], colorArea[i],_this.dataArray[dtname[i]], 0);
				    seriesArr.push(tempSeries);
				}
			}
            return  seriesArr;
        },
        setLineSeries:function(name,colorArea, data,type) {
            let series = {
                name:name,
                type:'line',
                smooth:false,
                symbolSize: 6,
                symbol: 'emptycircle',
                itemStyle: {
                    normal: {
                        label: {
                            formatter: function(params) {
                                return dataValue - params.value;
                            },
                            fontSize: 40,
                            padding: [90, 0, 0, 0],
                            color: '#fff',
                            textStyle: {
                                baseline: 'top'
                            }
                        },
						lineStyle:{
						   width:2,
						   type: type == 0 ? 'solid' : 'dotted' //'dotted'虚线 'solid'实线
					   }
                    }
                },
                areaStyle:colorArea,
                data:data
            };
            return series;
        },
        init(){
            let _this = this;
            _this.$echarts.init(document.getElementById(_this.id)).dispose();
            _this.chart = _this.$echarts.init(document.getElementById(_this.id));
            _this.chart.setOption(_this.lineOption());
            window.addEventListener("resize",function(){
                _this.chart.resize(); 
            });
        },
    },
}
</script>
<style lang="" scoped>
    .echart{width:100%;height:100%}
</style>


// WEBPACK FOOTER //
// src/components/echart/lineChart.vue